/**
 * Кнопка «?»: какое руководство открыть и на какой главе.
 *
 * Руководство лежит не в public/, а выдаётся сервером: приложение берёт
 * короткоживущий «билет» и открывает по нему файл. Роль в билет кладёт сервер,
 * из учётной записи, — значит показывается ровно своё, а чужого раздела там
 * физически нет. Подробнее — в backend/apps/help/views.py.
 *
 * Карта разделов — sections.json рядом. Тот же файл читает сборщик
 * scripts/build-qollanma.js: один файл на обе стороны, копии нет.
 *
 * Добавили страницу в меню (components/Layout.js) — впишите её путь в
 * sections.json, иначе «?» на ней откроет титульную страницу руководства.
 */

import toast from 'react-hot-toast';
import api, { API_BASE_URL } from '../api';
import MAP from './sections.json';

// Путь -> раздел. Длинный префикс проверяется первым: иначе «/sheet-terminal»
// поймался бы правилом «/sheet» и открыл главу про бирки вместо склада.
const RULES = MAP.sections
  .flatMap((s) => (s.paths || []).map((p) => [p, s]))
  .sort((a, b) => b[0].length - a[0].length);

/**
 * Якорь руководства для страницы.
 * @param {string|null} path  location.pathname
 * @param {string|null} view  раздел внутри страницы (проп section у Layout)
 */
export function helpAnchor(path, view) {
  if (!path) return 'home';
  const hit = RULES.find(([prefix]) => path === prefix || path.startsWith(prefix));
  if (!hit) return 'home';
  const sec = hit[1];
  // У страницы есть свои разделы — открываем сразу нужный пункт главы,
  // а не главу целиком: у склада их семь, и листать их у планшета незачем.
  const chapter = view && sec.views && sec.views[view];
  return chapter ? `${sec.slug}-${chapter}` : sec.slug;
}

/**
 * Открывает руководство в новой вкладке — на главе, относящейся к странице.
 *
 * Вкладку открываем СРАЗУ, до запроса: браузер считает попапом то окно, что
 * появилось не по нажатию, и блокирует его.
 */
export function openHelp(path, view) {
  const anchor = helpAnchor(path, view);
  const win = window.open('', '_blank');   // без noopener — иначе ссылка на окно теряется

  api.get('/help/ticket/')
    .then(({ data }) => {
      const url = `${API_BASE_URL}/help/doc/?t=${encodeURIComponent(data.token)}#${anchor}`;
      if (win) win.location.href = url;
      else window.location.href = url;     // попап заблокировали — открываем здесь
    })
    .catch((err) => {
      if (win) win.close();
      toast.error(err.response?.data?.error || 'Не удалось открыть руководство');
    });
}
